// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/payments/salary-payments/requests",
  Create: "/pyr/payments/salary-payments/requests",
  Update: "/pyr/payments/salary-payments/requests",
  Detail: "/pyr/payments/salary-payments/requests",
  Approve: "/pyr/payments/salary-payments/requests/approve",
};
